export enum UserType {
  consumer = 0,
  creator = 1,
  admin = 2,
  superAdmin = 3,
}
